/**
 * How many months the yearly plan saves, worked out from the plan prices
 * (V18.98, live test).
 *
 * The Premium sheet said "about 2 months free" as fixed text while
 * A$3.99 x 12 = A$47.88 against A$29.99 - nearer 4.5 months. Prices will
 * change before launch, so the number is computed from whatever the prices
 * are, never typed. Rounded to the nearest half month; null (the note is not
 * shown) when the yearly plan saves less than half a month.
 *
 * `plans` - [{ id: "yearly"|"monthly", amount: "29.99" }, ...]
 */
export function monthsFreeOnYearly(plans) {
  const list = plans || [];
  const yearly = Number((list.find((p) => p.id === "yearly") || {}).amount);
  const monthly = Number((list.find((p) => p.id === "monthly") || {}).amount);
  if (!(yearly > 0) || !(monthly > 0)) return null;
  const months = Math.round(((monthly * 12 - yearly) / monthly) * 2) / 2;
  return months >= 0.5 ? months : null;
}
